module.exports = __webpack_public_path__ + "static/media/3.3abef94c.jpg";